// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

export const INVESTMENT_HOLDINGS_V2_REDUCER_KEY = 'investmentHoldingsV2Store';

type InvestmentHoldingV2Type = {
  clientId: ?string,
  id: ?string,
  createdAt: ?string,
  accountId: string,
  symbol: ?string,
  securityName: ?string,
  quantity: ?number,
  currentPrice: ?number,
  marketValue: number,
  isDeleted: ?boolean,
  isCash: ?boolean,
};

export type InvestmentHoldingV2 = RecordOf<InvestmentHoldingV2Type>;
export const mkInvestmentHoldingV2: RecordFactory<InvestmentHoldingV2Type> =
  Record({
    clientId: undefined,
    id: undefined,
    createdAt: undefined,
    accountId: undefined,
    symbol: undefined,
    securityName: undefined,
    quantity: undefined,
    currentPrice: undefined,
    marketValue: undefined,
    isDeleted: undefined,
    isCash: undefined,
  });
